/*=========================================================================================
  File Name: main.js
  Description: main vue(js) file
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import Vue from 'vue'
import App from './App.vue'
import vSelect from 'vue-select'

Vue.component('v-select', vSelect)

// Vuesax Component Framework
import Vuesax from 'vuesax'
import 'material-icons/iconfont/material-icons.css' //Material Icons
import 'vuesax/dist/vuesax.css' // Vuesax
Vue.use(Vuesax)

// axios
import axios from './axios.js'
Vue.prototype.$http = axios

/*const cors = require('cors')
const corsConfig = {
  credentials: true,
  origin: true
}
Vue.use(cors(corsConfig))*/

// Filters
import './filters/filters.js'

// Theme Configurations
import '../themeConfig.js'

// Globally Registered Components
import './globalComponents.js'

// Styles: SCSS
import './assets/scss/main.scss'

// Tailwind
import '@/assets/css/main.css'

// Vue Router
import router from './router'

// Vuex Store
import store from './store/store'

// Vuejs - Vue wrapper for hammerjs
import { VueHammer } from 'vue2-hammer'
Vue.use(VueHammer)

// PrismJS
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'

// Feather font icon
require('./assets/css/iconfont.css')

//Validaciones
import VeeValidate from 'vee-validate'
Vue.use(VeeValidate)

// Vue select css
// Note: In latest version you have to add it separately
// import 'vue-select/dist/vue-select.css';

Vue.config.productionTip = false

//document.body.style.zoom = '85%'

import { searchCompany } from './config/companies.js'
//console.log('isUserLoggedIn', store.state.auth.isUserLoggedIn())
router.beforeEach((to, from, next) => {

  console.log('from', from)
  console.log('to', to)
  //console.log('fullPath', to.fullPath)
  //console.log('params', to.params)

  const companyName = to.params.nameCompany
  let companyNameEnabled = searchCompany(companyName)

  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (store.state.auth.isUserLoggedIn()) {

      //console.log('isuser', store.state.auth.isUserLoggedIn())
      console.log('user', store.state.auth.userDetails())

      const desc_copmany = store.state.auth.userDetails().desc_copmany

      companyNameEnabled = searchCompany(desc_copmany)

      if (companyNameEnabled) {

        //Valido si el usuario está autenticado
        if (
          to.matched.some(
            record => record.meta.windowRedirectAfter &&
              from.fullPath !== to.fullPath
          )
        ) {
          //valido si debo llegar al destino con refresh
          console.log('next 0')
          //console.log('to.fullPath', to.fullPath)

          if (to.fullPath !== '/') {

            if (to.fullPath.includes(`/${desc_copmany}`)) {
              next()
            } else {
              next({
                name: to.name,
                params: {
                  nameCompany: desc_copmany,
                  idRequest: to.params.idRequest
                }
              })
            }

          } else {
            window.location.href = to.fullPath
          }

        } else {
          console.log('next 1')
          next()
        }
      } else {
        alert('El nombre de la compañia no es correcto.')
      }
    } else {
      console.log('next 2')
      next({
        name: 'auth-login',
        params: { nameCompany: companyName, idRequest: to.params.idRequest }
      })
    }
  } else {
    console.log('next 3')

    if (to.name === '404') {
      //next(companyName + '/auth/error-404')
      next({
        name: 'page-error-404',
        params: { nameCompany: companyName, idRequest: to.params.idRequest }
      })
    } else {
      next() // make sure to always call next()!
    }
  }
})

axios.interceptors.response.use(
  function (response) {
    return response
  },
  function (error) {
    if (401 === error.response.status) {
      store.dispatch('auth/destroyToken').then(() => {
        console.log('caducado')
      })
      window.location = '/auth/logout'
    }
    return Promise.reject(error)
  }
)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
